import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const hiringProcessData = [
    {
        id: 1,
        question: "Strategic Discovery and Diagnostic",
        answer: "We conducted over 200 hours of intensive workshops and interviews to identify more than 100 specific pain points within the bank’s current lending and IT landscape. This diagnostic phase allowed us to align stakeholder goals with operational realities, ensuring our recommendations addressed the root causes of inefficiency."
    },
    {
        id: 2,
        question: "Future-State Design and Roadmapping",
        answer: "We conducted over 200 hours of intensive workshops and interviews to identify more than 100 specific pain points within the bank’s current lending and IT landscape. This diagnostic phase allowed us to align stakeholder goals with operational realities, ensuring our recommendations addressed the root causes of inefficiency."
    },
    {
        id: 3,
        question: "Platform Evaluation and Selection",
        answer: "We conducted over 200 hours of intensive workshops and interviews to identify more than 100 specific pain points within the bank’s current lending and IT landscape. This diagnostic phase allowed us to align stakeholder goals with operational realities, ensuring our recommendations addressed the root causes of inefficiency."
    },
    {
        id: 4,
        question: "Implementation and Ecosystem Integration",
        answer: "We conducted over 200 hours of intensive workshops and interviews to identify more than 100 specific pain points within the bank’s current lending and IT landscape. This diagnostic phase allowed us to align stakeholder goals with operational realities, ensuring our recommendations addressed the root causes of inefficiency."
    }
];

const HiringProcessFAQ = () => {
    const [openId, setOpenId] = useState(null);

    const fadeUpVariant = {
        hidden: { opacity: 0, y: 30 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } }
    };

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: { staggerChildren: 0.15 }
        }
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } }
    };

    return (
        <section className="w-full pb-[40px] md:pb-[100px] bg-white">
            <div className="max-w-[1440px] mx-auto px-[20px] md:px-[40px] lg:px-[80px]">
                <div className="flex flex-col lg:flex-row items-start gap-[24px] md:gap-[40px] lg:gap-[80px]">

                    <motion.div
                        initial={{ opacity: 0, y: -20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, amount: 0.3 }}
                        transition={{ duration: 0.8, ease: "easeOut" }}
                        variants={{
                            lg: { initial: { opacity: 0, x: -30, y: 0 }, whileInView: { opacity: 1, x: 0, y: 0 } }
                        }}
                        className="w-full lg:w-[267px] lg:sticky lg:top-[120px]"
                    >
                        <h2 className="font-sora text-[20px] lg:text-[30px] font-[600] text-[#01386A] tracking-tight leading-[1.2]">
                            Our Approach and Solution
                        </h2>
                    </motion.div>

                    <motion.div
                        variants={containerVariants}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.1 }}
                        className="w-full lg:w-full max-w-[793px] ml-auto flex flex-col gap-[16px] md:gap-[20px]"
                    >
                        {hiringProcessData.map((item) => {

                            return (
                                <motion.div
                                    key={item.id}
                                    variants={itemVariants}
                                    className="group relative bg-white border border-[#E4E8F5] p-[20px] sm:p-[24px] md:p-[40px] cursor-pointer transition-shadow duration-300 md:hover:shadow-[0_10px_30px_rgba(1,56,106,0.06)] rounded-sm"
                                >
                                    <h3 className="font-sora text-[16px] md:text-[20px] font-[600] text-[#01386A] mb-[12px] md:mb-[20px] pr-[20px]">
                                        {item.question}
                                    </h3>

                                    <AnimatePresence initial={false}>
                                        <motion.div
                                            initial={{ height: 0, opacity: 0 }}
                                            animate={{ height: "auto", opacity: 1 }}
                                            exit={{ height: 0, opacity: 0 }}
                                            transition={{ duration: 0.4, ease: "easeInOut" }}
                                            className="overflow-hidden"
                                        >
                                            <p className="font-graphik text-[#6C7689] text-[14px] md:text-[16px] font-[500] leading-[1.6] pt-[4px] md:pt-[10px]">
                                                {item.answer}
                                            </p>
                                        </motion.div>

                                    </AnimatePresence>

                                    <div className="absolute bottom-0 left-0 w-full h-[4px] bg-[#01386A] z-20"></div>
                                    <div className="absolute bottom-0 left-0 w-0 h-[4px] bg-[#ED6800] transition-all duration-500 ease-out group-hover:w-full z-30"></div>
                                </motion.div>
                            );
                        })}
                    </motion.div>

                </div>
            </div>
        </section>
    );
};

export default HiringProcessFAQ;